export const sliderModalDown = (isRTL: boolean, maxHeight?: string): any[] => [
	{
		offset: 0,
		width: '100%',
		maxHeight: maxHeight || '100dvh',
		left: !isRTL && '1.5rem',
		right: isRTL && '1.5rem',
		bottom: '2rem',
		transform: `translateX(${isRTL ? '10%' : '-10%'})`,
		borderRadius: '8px',
	},
	{
		offset: 0.25,
		width: '100%',
		maxHeight: '50vh',
		left: !isRTL && '30%',
		right: isRTL && '30%',
		bottom: '2rem',
		transform: `translateX(${isRTL ? '30%' : '-30%'})`,
		borderRadius: '8px',
	},
	{
		offset: 0.5,
		width: '420px',
		maxHeight: '40vh',
		left: !isRTL && '40%',
		right: isRTL && '40%',
		bottom: '2rem',
		transform: `translateX(${isRTL ? '40%' : '-40%'})`,
		borderRadius: '8px',
	},
	{
		offset: 1,
		width: '420px',
		maxHeight: '90px',
		left: !isRTL && '50%',
		right: isRTL && '50%',
		bottom: '2rem',
		transform: `translateX(${isRTL ? '50%' : '-50%'})`,
		borderRadius: '8px',
	},
]

export const sliderModalUp = (isRTL: boolean, maxHeight?: string): any[] => [
	{
		offset: 0,
		width: '100%',
		height: '90px',
		left: !isRTL && '50%',
		right: isRTL && '50%',
		bottom: '2rem',
		borderRadius: '8px',
	},
	{
		offset: 0.2,
		width: '100%',
		height: '40vh',
		left: !isRTL && '45%',
		right: isRTL && '45%',
		bottom: '2rem',
		borderRadius: '8px',
	},
	{
		offset: 0.5,
		width: '100%',
		height: '50vh',
		left: !isRTL && '25%',
		right: isRTL && '25%',
		bottom: '2rem',
		borderRadius: '8px',
	},
	{
		offset: 0.7,
		width: '430px',
		height: '70vh',
		left: !isRTL && '10%',
		right: isRTL && '10%',
		bottom: '2rem',
		borderRadius: '8px',
	},
	{
		offset: 1,
		width: '420px',
		height: maxHeight || '100dvh',
		left: !isRTL && '1.5rem',
		right: isRTL && '1.5rem',
		borderRadius: '8px',
		zIndex: 0,
	},
]

export const sliderModalDownAfterStyle = { height: 0 }
export const sliderModalUpAfterStyle = { height: '100dvh' }

export const contentModalDownAfterStyle = { opacity: 0 }
export const contentModalUpAfterStyle = { opacity: 1 }

export const sliderModalFooterUp = [
	{ offset: 0, opacity: 0, transform: 'translate(0px, 55px)' },
	{ offset: 1, opacity: 1, transform: 'translate(0px, 0px)' },
]

export const sliderModalFooterDown = [
	{ offset: 0, opacity: 1, transform: 'translate(0px, 0px)' },
	{ offset: 1, opacity: 0, transform: 'translate(0px, 55px)' },
]

export const modalFooterUpAfterStyle = { opacity: 0, transform: 'translate(0px, 55px)' }
export const modalFooterDownAfterStyle = { opacity: 1, transform: 'translate(0px, 0px)' }
